export const enum MenuItems {
  DASHBOARD = 'DASHBOARD',

  // GALLERY
  GALLERY_MAIN_MENU = 'GALLERY_MAIN_MENU',
  GALLERY = 'GALLERY',
  GALLERY_TAGS = 'GALLERY_TAGS',
}
